import React, { FC } from 'react';
import { serverSideTranslation } from '../../../util/next';

import { initSmartSiteData } from '../../../api/smartApi';
import { getPageContent } from '../../../api/pagesApi';

import { SmartPageContainer } from '../../../components/SmartPageContainer';
import NewsFooter from '../../../modules/NewsFooter';
import Page from '../../../components/Layout/Page';

const Environment: FC = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {} } = pageContentData || {};
  const description = shareContent.shareDetail || '推动绿色消费';
  const title = shareContent.shareTitle || '推动绿色消费';
  const pageUrl = '/csr/society/environment/meituan';

  return (
    <Page description={shareContent.shareDetail} title={shareContent.shareTitle} ogImageUrl={shareContent.shareImg}>
      <SmartPageContainer title={title} description={description} pageUrl={pageUrl} {...props} />{' '}
      <div className="bg-white">
        <NewsFooter category="csr" lanType={i18n.initialLocale} positionNo="csr_12" />
      </div>
    </Page>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr/society/environment',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_vse9270r',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...(await initSmartSiteData(locale)),
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common'])),
    },
  };
}
export default Environment;
